import React, { useState } from 'react';
import {
  Button,
  FormControl,
  InputAdornment,
  Modal,
  TextField,
} from '@material-ui/core';
import { ArrowRight, Phone } from 'phosphor-react';

import { togglePhoneNumberOauthModal } from '../../../../../actions/dashboard';
import {
  PhoneVerificationIcon,
  CheckmarkBlob,
} from '../../../../utility/Icons';
import { updateProfile } from '../../../../../actions/auth';
import { normalizePhone, parsePhoneNumber } from '../../../../../lib/helpers';
import styles from '../../../../../styles/sass/components/Verification.module.scss';

interface PhoneModalProps {
  phoneNumber: string | number | undefined;
  dispatch: Function;
  showPhoneNumberOauthModal: boolean;
  modalStyle: any;
  token: string;
}

export default function PhoneNumberOAuthModal({
  phoneNumber,
  dispatch,
  showPhoneNumberOauthModal,
  modalStyle,
  token,
}: PhoneModalProps) {
  const [tempNumber, setNumber] = useState(
    phoneNumber ? normalizePhone(`${phoneNumber}`) : '',
  );

  const [showDoneModal, toggleDoneModal] = useState(false);
  const [showHelperText, toggleHelperText] = useState(false);

  const handlePhoneNumber = (event: any) => {
    const text = event.target.value;
    const formattedNumber = normalizePhone(text);
    setNumber(formattedNumber);
    if (tempNumber.length > 0) {
      toggleHelperText(false);
    }
  };

  const updatePhoneNumber = () => {
    dispatch(updateProfile({ phoneNumber: tempNumber }, token, false, true));
    toggleDoneModal(true);
  };

  const phoneValid = parsePhoneNumber(tempNumber).length === 10;

  const handleClose = (event: any) => {
    if (tempNumber.length === 0) {
      toggleHelperText(true);
    }
  };

  return (
    <Modal
      open={showPhoneNumberOauthModal}
      onClose={handleClose}
      style={modalStyle}
    >
      <div className={styles.verificationModal}>
        <div className={styles.header}>
          {showDoneModal ? <CheckmarkBlob /> : <PhoneVerificationIcon />}
        </div>

        {showDoneModal ? (
          <React.Fragment>
            <h3
              className={styles.title}
              style={{ fontWeight: 600, fontSize: 24, lineHeight: 1.8 }}
            >
              Your phone number has been added to your account!
            </h3>
            <Button
              onClick={() => dispatch(togglePhoneNumberOauthModal(false))}
              className={`${styles.verifyButton} ${styles.validButton}`}
              style={{ margin: '10px 0px 10px 0px' }}
            >
              Awesome.{' '}
            </Button>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <h3 className={styles.title}>Add your phone number</h3>
            <p className={styles.titleSubText}>
              Don't worry, we're not signing you up for daily cat facts. We'll
              reach out for important things like new listings, open houses, and
              more!
            </p>
            <FormControl style={{ width: '90%' }}>
              <TextField
                autoFocus
                className={styles.numberField}
                fullWidth
                placeholder="(123)-456-7890"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Phone size={32} weight="fill" color="#195A50" />
                    </InputAdornment>
                  ),
                  disableUnderline: true,
                }}
                inputProps={{
                  style: {
                    color: '#2D2332',
                    fontSize: 24,
                    marginLeft: 10,
                  },
                }}
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  flexDirection: 'row',
                }}
                onChange={handlePhoneNumber}
                onFocus={() => toggleHelperText(false)}
                value={tempNumber}
              />
              {showHelperText && <p style={{ color: 'red' }}>{`* Required`}</p>}
            </FormControl>
            <Button
              onClick={updatePhoneNumber}
              disabled={!phoneValid}
              className={`${styles.verifyButton} ${
                phoneValid ? styles.validButton : styles.invalidButton
              }`}
              style={{ margin: '50px 0px 0px 0px' }}
            >
              Add Phone Number{' '}
              <ArrowRight
                color={phoneValid ? '#ffffff' : '#E2E2E2'}
                size={32}
                style={{ marginLeft: 10 }}
              />
            </Button>
          </React.Fragment>
        )}
      </div>
    </Modal>
  );
}
